// /pages/carrossier/FormulaireB/components/SectionMesures.js
import React from "react";

const SectionMesures = ({ formData, handleControleChange, productId }) => {
  return (
    <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
        <span className="text-xl">📊</span>
        10. Relevés et mesures
      </h3>
      
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">A - Pression coffret de commande (Bars)</label>
          <input
            type="number"
            step="0.1"
            placeholder="Ex: 12.5"
            value={formData.controles.relevesEtMesures?.pressionCoffretCommande || ""}
            onChange={(e) => handleControleChange("relevesEtMesures", "pressionCoffretCommande", e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">B - Temps de cycle montée (Secondes)</label>
          <input
            type="number"
            step="0.1"
            placeholder="Ex: 25.5"
            value={formData.controles.relevesEtMesures?.tempsCycleMontee || ""}
            onChange={(e) => handleControleChange("relevesEtMesures", "tempsCycleMontee", e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">C - Temps de cycle descente (Secondes)</label>
          <input
            type="number"
            step="0.1"
            placeholder="Ex: 30.2"
            value={formData.controles.relevesEtMesures?.tempsCycleDescente || ""}
            onChange={(e) => handleControleChange("relevesEtMesures", "tempsCycleDescente", e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">E - Tension à la batterie (V)</label>
          <input
            type="number"
            step="0.1"
            placeholder="Ex: 12.6"
            value={formData.controles.relevesEtMesures?.tensionBatterie || ""}
            onChange={(e) => handleControleChange("relevesEtMesures", "tensionBatterie", e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
      </div>
      
      {/* Contrôle des fuites vérin CLEVER SAFE */}
      <div className="bg-red-50 p-4 rounded-xl border border-red-200">
        <div className="mb-3">
          <span className="font-medium text-gray-900">D - Fuites (Vérin)</span>
          <p className="text-sm text-gray-600 mt-1">
            (après pulvérisation d'un détecteur de fuites)
          </p>
        </div>
        
        <div className="flex items-center gap-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name={`fuites_verin_${productId || 'default'}`}
              value="oui"
              checked={formData.controles.relevesEtMesures?.fuitesVerin === "oui"}
              onChange={() => handleControleChange("relevesEtMesures", "fuitesVerin", "oui")}
              className="text-green-600 focus:ring-green-500"
            />
            <span className="text-sm font-medium text-gray-700">Oui</span>
          </label>
          
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name={`fuites_verin_${productId || 'default'}`}
              value="non"
              checked={formData.controles.relevesEtMesures?.fuitesVerin === "non"}
              onChange={() => handleControleChange("relevesEtMesures", "fuitesVerin", "non")}
              className="text-green-600 focus:ring-green-500"
            />
            <span className="text-sm font-medium text-gray-700">Non</span>
          </label>
        </div>
      </div>
    </section>
  );
};

export default SectionMesures;